import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
var _Offer;
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import Country from "../country/Country";
import CountryCollection from "../country/CountryCollection";
import SalePageCollection from "../salePage/SalePageCollection";
import OfferSettings from "./OfferSettings";
import Image from "../image/Image";
import { levels } from "../../mcn-helpers";
import PreSellPageCollection from "../preSellPage/PreSellPageCollection";
import ImageCollection from "../image/ImageCollection";
import VideoCollection from "../video/VideoCollection";
import Product from "../product/Product";
import UserCollection from "../user/UserCollection";
import Store from "../domain/Store";
import JsonMappedModel from "../helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export class Offer extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Offer.id_attribute_name]: null,
      [Offer.country_id_attribute_name]: null,
      [Offer.product_id_attribute_name]: null,
      [Offer.offer_product_attribute_name]: Product,
      [Offer.active_product_attribute_name]: Product,
      [Offer.product_attribute_name]: Product,
      [Offer.name_attribute_name]: null,
      [Offer.payout_attribute_name]: null,
      [Offer.description_attribute_name]: null,
      [Offer.type_attribute_name]: null,
      [Offer.offer_price_attribute_name]: null,
      [Offer.offer_country_attribute_name]: Country,
      [Offer.country_attribute_name]: Country,
      [Offer.offer_order_lines_attribute_name]: null,
      [Offer.sale_pages_attribute_name]: SalePageCollection,
      [Offer.offer_active_sale_pages_attribute_name]: SalePageCollection,
      [Offer.active_sale_pages_attribute_name]: SalePageCollection,
      [Offer.payment_type_attribute_name]: null,
      [Offer.shipping_countries_select_type_attribute_name]: Offer.MULTIPLE_COUNTRY_SELECT_TYPE,
      [Offer.shipping_countries_attribute_name]: CountryCollection,
      [Offer.sale_price_attribute_name]: null,
      [Offer.offer_with_trashed_product_attribute_name]: Product,
      [Offer.with_trashed_product_attribute_name]: Product,
      [Offer.settings_attribute_name]: OfferSettings,
      [Offer.pre_sell_pages_attribute_name]: PreSellPageCollection,
      [Offer.network_commission_attribute_name]: 0,
      [Offer.status_attribute_name]: Offer.DRAFT_STATUS,
      [Offer.status_required_for_commission_attribute_name]: null,
      [Offer.required_activity_points_attribute_name]: 0,
      [Offer.product_ad_copy_attribute_name]: 0,
      [Offer.product_ad_images_attribute_name]: ImageCollection,
      [Offer.product_ad_videos_attribute_name]: VideoCollection,
      [Offer.exclusive_users_attribute_name]: UserCollection,
      [Offer.offer_domain_attribute_name]: Store,
      [Offer.created_at_attribute_name]: null,
      [Offer.offer_image_attribute_name]: null,
      [Offer.default_domain_attribute_name]: Store,
      [Offer.offer_offer_requests_count_attribute_name]: null,
      [Offer.offer_offer_requests_order_shipped_attribute_name]: null,
      [Offer.offer_inventories_attribute_name]: null
    });
    _defineProperty(this, "OfferTab", {
      id: 'offer-form-tab',
      fieldName: 'tab',
      fieldTitle: 'Offer ',
      loading: false,
      content: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getOfferProductAttributeName() {
    return Offer.offer_product_attribute_name;
  }
  static getProductAttributeName() {
    return Offer.product_attribute_name;
  }
  static getNameAttributeName() {
    return Offer.name_attribute_name;
  }
  static getDescriptionAttributeName() {
    return Offer.description_attribute_name;
  }
  static getTypeAttributeName() {
    return Offer.type_attribute_name;
  }
  static getExclusiveUsersAttributeName() {
    return Offer.exclusive_users_attribute_name;
  }
  static getRequiredActivityPointsAttributeName() {
    return Offer.required_activity_points_attribute_name;
  }
  static getStatusAttributeName() {
    return Offer.status_attribute_name;
  }
  static getPaymentTypeAttributeName() {
    return Offer.payment_type_attribute_name;
  }
  static getStatusRequiredForCommissionAttributeName() {
    return Offer.status_required_for_commission_attribute_name;
  }
  static getPayoutAttributeName() {
    return Offer.payout_attribute_name;
  }
  static getNetworkCommissionAttributeName() {
    return Offer.network_commission_attribute_name;
  }
  static getOfferCountryAttributeName() {
    return Offer.offer_country_attribute_name;
  }
  static getCountryAttributeName() {
    return Offer.country_attribute_name;
  }
  static getShippingCountriesSelectTypeAttributeName() {
    return Offer.shipping_countries_select_type_attribute_name;
  }
  static getShippingCountriesAttributeName() {
    return Offer.shipping_countries_attribute_name;
  }
  static getSettingsAttributeName() {
    return Offer.settings_attribute_name;
  }
  static getProductAdCopyAttributeName() {
    return Offer.product_ad_copy_attribute_name;
  }
  static getProductAdImagesAttributeName() {
    return Offer.product_ad_images_attribute_name;
  }
  static getProductAdVideosAttributeName() {
    return Offer.product_ad_videos_attribute_name;
  }
  static getDefaultDomainAttributeName() {
    return Offer.default_domain_attribute_name;
  }
  static getSalePagesAttributeName() {
    return Offer.sale_pages_attribute_name;
  }
  getId() {
    return this.getAttribute(Offer.id_attribute_name);
  }
  getName() {
    return this.getAttribute(Offer.name_attribute_name);
  }
  getShippingCountries() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(Offer.shipping_countries_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getSalePrice() {
    return this.getAttribute(Offer.sale_price_attribute_name);
  }
  getDescription() {
    return this.getAttribute(Offer.description_attribute_name);
  }
  getPaymentType() {
    return this.getAttribute(Offer.payment_type_attribute_name);
  }
  getOfferCountry() {
    return this.getAttribute(Offer.offer_country_attribute_name);
  }
  getCountry() {
    var _this$getOfferCountry;
    return (_this$getOfferCountry = this.getOfferCountry()) !== null && _this$getOfferCountry !== void 0 ? _this$getOfferCountry : this.getAttribute(Offer.country_attribute_name);
  }
  getProduct(trashed = false) {
    var _this$getAttribute3;
    if (trashed) {
      var _this$getAttribute2;
      return (_this$getAttribute2 = this.getAttribute(Offer.offer_with_trashed_product_attribute_name)) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : this.getAttribute(Offer.with_trashed_product_attribute_name);
    }
    return (_this$getAttribute3 = this.getAttribute(Offer.offer_product_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : this.getAttribute(Offer.product_attribute_name);
  }

  /*    getProduct(trashed = false) {
          if (trashed) return this.OfferWithTrashedProduct.content ?? this.withTrashedProduct.content
           return this.OfferProduct.content ?? this.product.content
      }*/

  getFirstActiveSalePage() {
    var _this$getActiveSalePa, _this$getActiveSalePa2;
    return (_this$getActiveSalePa = (_this$getActiveSalePa2 = this.getActiveSalePages()) === null || _this$getActiveSalePa2 === void 0 ? void 0 : _this$getActiveSalePa2[0]) !== null && _this$getActiveSalePa !== void 0 ? _this$getActiveSalePa : null;
  }
  getOfferProductImage() {
    let product = this.getOfferProduct();
    /*console.log('getOfferProductImage', product)
    console.log('product instanceof Product', product instanceof Product)
    console.log('product.prototype', product.prototype)*/
    return product instanceof Product ? product.getImage() : null;
  }
  getOfferSalePages() {
    var _this$getAttribute4;
    return (_this$getAttribute4 = this.getAttribute(Offer.sale_pages_attribute_name)) !== null && _this$getAttribute4 !== void 0 ? _this$getAttribute4 : [];
  }
  getOfferFirstSalePage() {
    return this.getOfferSalePages()[0];
  }
  getActiveSalePages() {
    var _this$getAttribute5;
    return (_this$getAttribute5 = this.getAttribute(Offer.active_sale_pages_attribute_name)) !== null && _this$getAttribute5 !== void 0 ? _this$getAttribute5 : [];
  }
  getShippingCountrySelectType() {
    return this.getAttribute(Offer.shipping_countries_select_type_attribute_name);
  }
  isCardPayment() {
    return this.getPaymentType() === Offer.CARD_PAYMENT_TYPE;
  }
  getPayout() {
    return this.getAttribute(Offer.payout_attribute_name);
  }
  getProductImage() {
    let product = this.getProduct();
    return product instanceof Product ? product.getImage() : null;
  }
  getSettings() {
    return this.getAttribute(Offer.settings_attribute_name);
  }
  getStatistics() {
    let settings = this.getSettings();
    return settings instanceof OfferSettings ? settings.getStatistics() : null;
  }
  getImage() {
    let product = this.getOfferProduct();
    return product instanceof Product ? product.getImage() : null;
  }
  getSalePages() {
    return this.getAttribute(Offer.sale_pages_attribute_name);
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getOfferId() {
    return this.getAttribute(Offer.id_attribute_name);
  }
  getOfferProduct() {
    var _this$getAttribute6;
    return (_this$getAttribute6 = this.getAttribute(Offer.offer_product_attribute_name)) !== null && _this$getAttribute6 !== void 0 ? _this$getAttribute6 : this.getAttribute(Offer.active_product_attribute_name);
  }
  getPreSellPages() {
    return this.getAttribute(Offer.pre_sell_pages_attribute_name);
  }
  getProductId() {
    return this.getAttribute(Offer.product_id_attribute_name);
  }
  isCardPaymentType() {
    return this.getPaymentType() === Offer.CARD_PAYMENT_TYPE;
  }
  getShippingCountriesSelectType() {
    return this.getAttribute(Offer.shipping_countries_select_type_attribute_name);
  }
  isWorldWide() {
    return this.getShippingCountriesSelectType() === Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE;
  }
  isMultipleCountries() {
    return this.getShippingCountriesSelectType() === Offer.MULTIPLE_COUNTRY_SELECT_TYPE;
  }
  isSingleCountry() {
    return this.getShippingCountriesSelectType() === Offer.SAME_COUNTRY_SELECT_TYPE;
  }
  getOfferProductName() {
    let offerProduct = this.getOfferProduct();
    return offerProduct instanceof Product ? offerProduct.getName() : null;
  }
  getOfferProductImageUrl() {
    let offerProductImage = this.getOfferProductImage();
    //console.log('offerProductImage', offerProductImage)
    return offerProductImage instanceof Image ? offerProductImage.getUrl() : null;
  }
  getCountryNameTranslationWithEmoji(lang) {
    let country = this.getOfferCountry();
    return country instanceof Country ? country.getNameTranslationWithEmoji(lang) : null;
  }
  getOfferPayout() {
    return this.getAttribute(Offer.payout_attribute_name);
  }
  getOfferName() {
    return this.getAttribute(Offer.name_attribute_name);
  }
  getOfferCommission() {
    return this.getAttribute(Offer.network_commission_attribute_name);
  }
  getStatus() {
    return this.getAttribute(Offer.status_attribute_name);
  }
  getOfferSelectObject(text = 'text', value = 'value') {
    return {
      [text]: this.getOfferName(),
      [value]: this.getId()
    };
  }
  statusRequiredForCommission() {
    return this.getAttribute(Offer.status_required_for_commission_attribute_name);
  }
  getStatusRequiredForCommission() {
    return this.getAttribute(Offer.status_required_for_commission_attribute_name);
  }
  canBeShippedOutdoor() {
    return [Offer.MULTIPLE_COUNTRY_SELECT_TYPE, Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE].includes(this.getShippingCountriesSelectType());
  }
  getType() {
    return this.getAttribute(Offer.type_attribute_name);
  }
  isStandard() {
    return this.getType() === Offer.STANDARD_TYPE;
  }
  getCurrencySymbol() {
    if (this.canBeShippedOutdoor()) return null;
    let country = this.getCountry();
    return country instanceof Country ? country.getCurrencySymbol() : null;
  }
  getRequiredActivityScore() {
    return this.getAttribute(Offer.required_activity_points_attribute_name);
  }
  getProductAdCopy() {
    return this.getAttribute(Offer.product_ad_copy_attribute_name);
  }
  getProductAdImages() {
    return this.getAttribute(Offer.product_ad_images_attribute_name);
  }
  getProductAdVideos() {
    return this.getAttribute(Offer.product_ad_videos_attribute_name);
  }
  getLevel() {
    var _levels$find;
    let levelPoints = levels.reduce((init, level) => {
      if (level.points > this.getRequiredActivityScore()) return init;
      return level.points > init ? level.points : init;
    }, 0);
    return (_levels$find = levels.find(level => level.points === levelPoints)) === null || _levels$find === void 0 ? void 0 : _levels$find.level_sym;
  }
  getDefaultDomain() {
    return this.getAttribute(Offer.default_domain_attribute_name);
  }
}
_Offer = Offer;
_defineProperty(Offer, "ACTIVE_STATUS", 'active');
_defineProperty(Offer, "PAUSED_STATUS", 'paused');
_defineProperty(Offer, "DRAFT_STATUS", 'draft');
_defineProperty(Offer, "STANDARD_TYPE", 'standard');
_defineProperty(Offer, "VIP_TYPE", 'vip');
_defineProperty(Offer, "EXCLUSIVE_TYPE", 'exclusive');
_defineProperty(Offer, "PRIVATE_TYPE", 'private');
_defineProperty(Offer, "TEST_TYPE", 'test');
_defineProperty(Offer, "COD_PAYMENT_TYPE", 'cod');
_defineProperty(Offer, "CARD_PAYMENT_TYPE", 'card');
_defineProperty(Offer, "CARD_PAYMENT_TYPE_ALTERNATIVE", 'pre-paid');
_defineProperty(Offer, "OPTION_VALUE_KEY", _Offer.getIdAttributeName());
_defineProperty(Offer, "OPTION_TEXT_KEY", _Offer.getNameAttributeName());
_defineProperty(Offer, "CONFIRMED_COMMISSION_TYPE", 'confirmed');
_defineProperty(Offer, "DELIVERED_COMMISSION_TYPE", 'delivered');
_defineProperty(Offer, "SAME_COUNTRY_SELECT_TYPE", 'same-country');
_defineProperty(Offer, "WORLD_WIDE_COUNTRY_SELECT_TYPE", 'world-wide');
_defineProperty(Offer, "MULTIPLE_COUNTRY_SELECT_TYPE", 'multiple-countries');
_defineProperty(Offer, "id_attribute_name", 'offer_id');
_defineProperty(Offer, "country_id_attribute_name", 'country_id');
_defineProperty(Offer, "product_id_attribute_name", 'product_id');
_defineProperty(Offer, "offer_product_attribute_name", 'offer_product');
_defineProperty(Offer, "active_product_attribute_name", 'active_product');
_defineProperty(Offer, "product_attribute_name", 'product');
_defineProperty(Offer, "name_attribute_name", 'offer_name');
_defineProperty(Offer, "payout_attribute_name", 'offer_payout');
_defineProperty(Offer, "description_attribute_name", 'offer_description');
_defineProperty(Offer, "type_attribute_name", 'offer_type');
_defineProperty(Offer, "offer_price_attribute_name", 'offer_price');
_defineProperty(Offer, "offer_country_attribute_name", 'offer_country');
_defineProperty(Offer, "country_attribute_name", 'country');
_defineProperty(Offer, "offer_order_lines_attribute_name", 'offer_order_lines');
_defineProperty(Offer, "sale_pages_attribute_name", 'offer_sale_pages');
_defineProperty(Offer, "offer_active_sale_pages_attribute_name", 'offer_active_sale_pages');
_defineProperty(Offer, "active_sale_pages_attribute_name", 'active_sale_pages');
_defineProperty(Offer, "payment_type_attribute_name", 'offer_payment_type');
_defineProperty(Offer, "shipping_countries_select_type_attribute_name", 'shipping_countries_select_type');
_defineProperty(Offer, "shipping_countries_attribute_name", 'offer_shipping_countries');
_defineProperty(Offer, "sale_price_attribute_name", 'sale_price');
_defineProperty(Offer, "offer_with_trashed_product_attribute_name", 'offer_with_trashed_product');
_defineProperty(Offer, "with_trashed_product_attribute_name", 'with_trashed_product');
_defineProperty(Offer, "settings_attribute_name", 'settings');
_defineProperty(Offer, "pre_sell_pages_attribute_name", 'pre_sell_pages');
_defineProperty(Offer, "network_commission_attribute_name", 'offer_network_commission');
_defineProperty(Offer, "status_attribute_name", 'offer_status');
_defineProperty(Offer, "status_required_for_commission_attribute_name", 'status_required_for_commission');
_defineProperty(Offer, "required_activity_points_attribute_name", 'offer_required_activity_points');
_defineProperty(Offer, "product_ad_copy_attribute_name", 'offer_product_ad_copy');
_defineProperty(Offer, "product_ad_images_attribute_name", 'offer_product_ad_images');
_defineProperty(Offer, "product_ad_videos_attribute_name", 'offer_product_ad_videos');
_defineProperty(Offer, "exclusive_users_attribute_name", 'offer_exclusive_users');
_defineProperty(Offer, "offer_domain_attribute_name", 'offer_domain');
_defineProperty(Offer, "created_at_attribute_name", 'created_at');
_defineProperty(Offer, "offer_image_attribute_name", 'offer_image');
_defineProperty(Offer, "default_domain_attribute_name", 'offer_default_domain');
_defineProperty(Offer, "offer_offer_requests_count_attribute_name", 'offer_offer_requests_count');
_defineProperty(Offer, "offer_offer_requests_order_shipped_attribute_name", 'offer_offer_requests_order_shipped');
_defineProperty(Offer, "offer_inventories_attribute_name", 'offer_inventories');
export default Offer;